export const users = ['byron@choice.aero', 'mozart@choice.aero', 'frank@choice.aero', 'iqra@choice.aero', 'julio@choice.aero', 'schoi@choice.aero'];
